import { getNavBarStatus } from '../actions/ui';
import { types } from '../types/types';

const initialState = {
	theme: getNavBarStatus(),
};

export const uiReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.setTheme:
			return {
				...state,
				theme: action.payload,
			};

		case types.setResetUI:
			return initialState;

		default:
			return state;
	}
};
